/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState,useEffect,useRef  } from "react";
import ReactDOM from "react-dom";
import axios from 'axios';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
// reactstrap components
import { Container, Row, Col } from "reactstrap";
import { Table } from 'reactstrap';
import { Button } from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, Form, FormGroup } from 'reactstrap';
import { connect } from 'react-redux';
import {setProducts} from '../../actions/quote'
import Category from "../Category.js"
import {supplier_arry} from "../../config"
import Brand from "../Orderspart/Brand"
import Visuals from "../Orderspart/Visuals"
import Production from "../Orderspart/Production"
import Allquotes from "../Orderspart/Allquotes"
import Quotes from "../Orderspart/Quotes"
import Jobs from "../Orderspart/Jobs"

// core components
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import CardsFooter from "components/Footers/CardsFooter.js";
import {
  SortableContainer,
  SortableElement,
  arrayMove
} from "react-sortable-hoc";

import "react-virtualized/styles.css";
import "assets/vendor/font-awesome/css/font-awesome.min.css";
// index page sections
// import Hero from "./IndexSections/Hero.js";
// import Buttons from "./IndexSections/Buttons.js";
// import Inputs from "./IndexSections/Inputs.js";
// import CustomControls from "./IndexSections/CustomControls.js";
// import Menus from "./IndexSections/Menus.js";
// import Navbars from "./IndexSections/Navbars.js";
// import Tabs from "./IndexSections/Tabs.js";
// import Progress from "./IndexSections/Progress.js";
// import Pagination from "./IndexSections/Pagination.js";
// import Pills from "./IndexSections/Pills.js";
// import Labels from "./IndexSections/Labels.js";
// import Alerts from "./IndexSections/Alerts.js";
// import Typography from "./IndexSections/Typography.js";
import Product from "../IndexSections/Product.js";
// import Datepicker from "./IndexSections/Datepicker.js";
// import TooltipPopover from "./IndexSections/TooltipPopover.js";
// import Carousel from "./IndexSections/Carousel.js";
// import Icons from "./IndexSections/Icons.js";
// import Login from "./IndexSections/Login.js";
// import Download from "./IndexSections/Download.js";
import { TabContent, TabPane, Nav, NavItem, NavLink, Card, CardTitle, CardText } from 'reactstrap';
import classnames from 'classnames';
import SelectSearch from '../IndexSections/SelectSearch.js';




function Index(props) {
  const main = useRef();
  const [activeTab, setActiveTabe] = useState('1');  
  const [contacts, setContacts] = useState([]);
  const [contactInfo, setContactInfo] = useState("");
  const [selectedUser, setselectedUser] = useState(null);
  const [selectedContact, setselectedContact] = useState(null);
  
  const [companies, setCompanies] = useState(null);

  useEffect(() => {
    axios.get(`/contacts/getcontactsforsearch`).then(res => {
      if(res.data.status == "success"){     
        setCompanies(res.data.data)
      }
    }) 
  },[]);

  const toggle=(tab)=> {
    if (activeTab !== tab) {
      setActiveTabe(tab)
    }
  }

  const onChangeCompany=(values)=>{
    var value = null;
    if(values && values.length> 0){
      value = values[0]['key'];
      var tmp = value.split(" - ")
      var user = tmp[0]; var contact = tmp[1];
      setselectedUser(user)
      setselectedContact(contact)
      axios.get(`/contacts/getcontact?id=${contact}`).then(res => {
        if(res.data.status == "success"){     
          setContactInfo(res.data.data)
        }
      }) 
    }    
  }

  const createQuote = ()=>{
    if(selectedUser)
      props.history.push(`/admin/requests/add/?user=${selectedUser}`)
    else{
      alert("Please select company first.");
    }
  }

  return (
    <>
      <DemoNavbar />
      <main ref={main}>
        <Container fluid="lg" className="m-auto">
          <Row>
            <Col md="12">
              <FormGroup className="">        
                <Button className="btn-icon btn-2 float-right" color="primary" type="button"  onClick={createQuote}>
                  <span className="btn-inner--icon mr-2">
                    <i className="fa fa-plus" />
                  </span>
                  NEW QUOTE REQUEST
                </Button>                      
                <Button className="btn-icon btn-2 float-right mr-2" color="primary" type="button"  onClick={()=>{props.history.push(`/admin/myorders`)}}>
                  <span className="btn-inner--icon mr-2">
                    <i className="fa fa-plus" />
                  </span>
                  NEW CLIENT
                </Button>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            {companies && companies.length > 0 &&
            <Col sm="3">
                <SelectSearch className="select-company" options={companies} placeholder="Search Company" onChange={values => {onChangeCompany(values)}} searchBy="label" labelField="label" valueField="key" />
              {
                  (contactInfo) &&
                      <div className="position-relative" style={{fontSize:'13.5px', padding:'5px'}}>
                        <div className=" mb-0">
                          {contactInfo['company']?contactInfo['company']:""}<br/>
                          {contactInfo['mobile']?contactInfo['mobile']:""}<br/><br/>
                          {contactInfo['address']?contactInfo['address']:""}<br/>
                          {(contactInfo['suburb']?(contactInfo['suburb']+", "):"")+(contactInfo['state']?(contactInfo['state']+", "):"")+(contactInfo['postcode']?contactInfo['postcode']:"")}<br/>
                        </div>
                      </div>
                }
            </Col>
            }
          </Row>
          <Row className="mt-3 orders-tabs">
            <Col  md="12">
              <div>
                <Nav tabs>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '1' })}
                      onClick={() => { toggle('1'); }}
                    >
                      All Quotes
                    </NavLink>
                  </NavItem>
                </Nav>
                <TabContent activeTab={activeTab}>
                  <TabPane tabId="1" className="">
                    <Row>
                      <Col sm="12">
                        <Card body>
                          <Allquotes history={props.history} selectedUser={selectedUser} selectedContact={selectedContact}/>
                        </Card>
                      </Col>
                    </Row>
                  </TabPane>
                </TabContent>
              </div>
            </Col>
          </Row>
        </Container>
      </main>
      <CardsFooter/>
    </>
  );
}


const mapStateToProps = (state) => {
  return {
    quote: state.quote,
  };
};

const mapDispatchProps = (dispatch) => {
  return {    
    setProducts: products=>dispatch(setProducts(products)),
  };
};

export default connect(mapStateToProps, mapDispatchProps)(Index);
